function inferLocalApiBase() {
  return 'https://leadsbackend.riverprime.com';
}

const API_BASE = process.env.REACT_APP_API_URL || inferLocalApiBase();
const TOKEN_KEY = 'river_tracker_token';

function buildUrl(path) {
  if (!path.startsWith('/')) return `${API_BASE}/${path}`;
  return `${API_BASE}${path}`;
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

function emitAuthExpired(reason) {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent('river-auth-expired', { detail: { reason: reason || 'Unauthorized' } }));
  } catch (_e) {
    // no-op
  }
}

async function request(path, options) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(options && options.headers ? options.headers : {}),
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(buildUrl(path), {
    ...options,
    headers,
  });

  const text = await res.text();
  let data = {};
  const contentType = (res.headers.get('content-type') || '').toLowerCase();
  const isJson = contentType.includes('application/json');

  if (text) {
    if (isJson) {
      try {
        data = JSON.parse(text);
      } catch (_e) {
        throw new Error('Server returned invalid JSON.');
      }
    } else {
      const looksLikeHtml = /^\s*</.test(text);
      if (looksLikeHtml) {
        throw new Error('API endpoint returned HTML instead of JSON. Check REACT_APP_API_URL or server rewrites for /api.');
      }
      data = { error: text };
    }
  }

  if (!res.ok) {
    const message = data && data.error ? data.error : `Request failed (${res.status})`;
    if (res.status === 401) {
      clearToken();
      emitAuthExpired(message);
    }
    throw new Error(message);
  }

  return data;
}

export function apiGet(path) {
  return request(path, { method: 'GET' });
}

export function apiPost(path, body) {
  return request(path, { method: 'POST', body: JSON.stringify(body || {}) });
}

export function apiPut(path, body) {
  return request(path, { method: 'PUT', body: JSON.stringify(body || {}) });
}

export function apiDelete(path) {
  return request(path, { method: 'DELETE' });
}
